define('responsive-gameday/views/Monitor/Events/SceneStateEvents',{
    SCENE_STATE_UPDATE: "sceneStateUpdate",
    NEW_BATTER: "newBatter",
    NEW_LEFT_HANDED_BATTER: "newLeftHandedBatter",
    NEW_LEFT_HANDED_BATTER_WITH_PITCHES: "newLeftHandedBatterWithPitches",
    NEW_RIGHT_HANDED_BATTER: "newRightHandedBatter",
    NEW_RIGHT_HANDED_BATTER_WITH_PITCHES: "newRightHandedBatterWithPitches",
    NEW_RIGHT_HANDED_HIT: "newRightHandedHit",
    NEW_LEFT_HANDED_HIT: "newLeftHandedHit",

    BATTER_SWITCHED_TO_LEFT_HANDED: "batterSwitchedToLeftHanded",
    BATTER_SWITCHED_TO_RIGHT_HANDED: "batterSwitchedToRightHanded",

    //all possible ball-strike counts
    COUNT_CHANGE: "countChange",
    COUNT_4_2: "count42",
    COUNT_4_1: "count41",
    COUNT_4_0: "count40",
    COUNT_3_3: "count33",
    COUNT_3_2: "count32",
    COUNT_3_1: "count31",
    COUNT_3_0: "count30",
    COUNT_2_3: "count23",
    COUNT_2_2: "count22",
    COUNT_2_1: "count21",
    COUNT_2_0: "count20",
    COUNT_1_3: "count13",
    COUNT_1_2: "count12",
    COUNT_1_1: "count11",
    COUNT_1_0: "count10",
    COUNT_0_3: "count03",
    COUNT_0_2: "count02",
    COUNT_0_1: "count01",
    COUNT_0_0: "count00",

    //all possible runners-on-base scenarios
    BASES_EMPTY: "basesEmpty",
    RUNNER_ON_FIRST: "runnerOnFirst",
    RUNNER_ON_SECOND: "runnerOnSecond",
    RUNNER_ON_THIRD: "runnerOnThird",
    RUNNERS_ON_FIRST_AND_SECOND: "runnersOnFirstAndSecond",
    RUNNERS_ON_FIRST_AND_THIRD: "runnersOnFirstAndThird",
    RUNNERS_ON_SECOND_AND_THIRD: "runnersOnSecondAndThird",
    BASES_LOADED: "basesLoaded",
    RUNNERS_IN_SCORING_POSITION: "runnersInScoringPosition",

    //game state changes
    GAME_STATE_CHANGE_TO_IN_PROGRESS: "gameStateChangeToInProgress",
    GAME_STATE_CHANGE_TO_WARMUP: "gameStateChangeToWarmup",
    GAME_STATE_CHANGE_TO_PREVIEW: "gameStateChangeToPreview",
    GAME_STATE_CHANGE_TO_PREGAME: "gameStateChangeToPreGame",
    GAME_STATE_CHANGE_TO_LINEUPS: "gameStateChangeToLineups",
    GAME_STATE_CHANGE_TO_DELAYED: "gameStateChangeToDelayed",
    GAME_STATE_CHANGE_TO_DELAYED_START: "gameStateChangeToDelayedStart",
    GAME_STATE_CHANGE_TO_FINAL: "gameStateChangeToFinal",
    GAME_STATE_CHANGE_TO_GAME_OVER: "gameStateChangeToGameOver",
    GAME_STATE_CHANGE_TO_COMPLETED_EARLY: "gameStateChangeToCompletedEarly",
    GAME_STATE_CHANGE_TO_SUSPENDED: "gameStateChangeToSuspended",
    GAME_STATE_CHANGE_TO_CANCELLED: "gameStateChangeToCancelled",
    GAME_STATE_CHANGE_TO_POSTPONED: "gameStateChangeToPostponed",
    GAME_STATE_CHANGE_TO_FORFEIT: "gameStateChangeToForfeit",
    GAME_STATE_CHANGE_TO_INSTANT_REPLAY: "gameStateChangeToInstantReplay",
    GAME_STATE_CHANGE_TO_EXTRA_INNINGS: "gameStateChangeToExtraInnings",

    //abstract game states are groupings of the above game states
    //e.g. abstract pre-game is preview, lineups, or pregame.
    ABSTRACT_GAME_STATE_CHANGE_TO_PREGAME: "abstractGameStateChangeToPregame",
    ABSTRACT_GAME_STATE_CHANGE_TO_LIVE: "abstractGameStateChangeToLive",
    ABSTRACT_GAME_STATE_CHANGE_TO_DELAYED: "abstractGameStateChangeToDelayed",
    ABSTRACT_GAME_STATE_CHANGE_TO_FINAL: "abstractGameStateChangeToFinal",
    ABSTRACT_GAME_STATE_CHANGE_TO_OTHER: "abstractGameStateChangeToOther",

    UI_GAME_STATE_CHANGE_TO_PREGAME: "UIGameStateChangeToPregame",
    UI_GAME_STATE_CHANGE_TO_LIVE: "UIGameStateChangeToLive",
    UI_GAME_STATE_CHANGE_TO_FINAL: "UIGameStateChangeToFinal",

    //substitutions
    DEFENSIVE_SUBSTITUTION: "defensiveSubstitution",
    OFFENSIVE_SUBSTITUTION: "offensiveSubstitution",
    PITCHER_CHANGE: "pitcherChange",
    PITCHER_CHANGE_COMPLETE: "pitcherChangeComplete",
    COACH_TO_MOUND: "coachToMound",

    //mid-inning
    MID_INNING: "midInning",
    NEW_HALF_INNING: "newHalfInning",
    NEW_VIDEO_HIGHLIGHTS: "newVideoHighlights",
    COMMERCIAL_BREAK_BEGIN: "beginCommercialBreak",
    COMMERCIAL_BREAK_END: "endCommercialBreak"
});
